export default "__VITE_ASSET__B3h87uGT__"